<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-11 p-0">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="details-background">
        <div class="breadcrumbs-section">
          <span class="prev-page "><a routerLink="/overview">Home</a></span>
          <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
          <span class="prev-page  "><a routerLink="/members/members-list">Members</a></span>
          <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
          <span class="curr-page breadcrumbs-section-font">Member Details</span>
        </div>
        <label class="meetings padding-left-employees">Member Details</label>
        <div class="col-12 row d-flex padding-left-employees">
          <div class="col-5 flex-column pt-3">
            <div class="d-flex flex-column">
              <span class="name">
                Member Name
              </span>
              <span class="details">
                {{employeeDetails?.userName}}
              </span>
            </div>

            <div class="d-flex flex-column pt-3 white-space">
              <span class="name">
                Company Name
              </span>
              <span class="details">
                {{details?.t0200OrgEmployees[0]?.tenant?.companyName}}
              </span>
            </div>
          </div>
          <div class="col-5 flex-column pt-3">
            <div class="d-flex flex-column white-space">
              <span class="name">
                Email Id
              </span>
              <span class="details">
                {{employeeDetails?.emailId}}
              </span>
            </div>

            <div class="d-flex flex-column pt-3 white-space">
              <span class="name">
                TA Name
              </span>
              <span class="details">
                {{details?.t0200OrgEmployees[0]?.tenant?.adminName}}
              </span>
            </div>

          </div>

          <div class="col-2">
            <div class="circle">
              <div class="circle-name">{{acronym}}</div>
            </div>
          </div>
        </div>
        <div class="col-12 row d-flex padding-left-employees">
          <div class="col-5 flex-column pt-3 white-space">
            <div class="d-flex flex-column">
              <span class="name">
                Activation Date
              </span>
              <span class="details">
                <!-- 08 - 04 - 19 -->
                {{convertDateFormat("08-04-2019")}}
              </span>
            </div>
          </div>
          <div class="col-5 flex-column pt-3 white-space">
            <div class="d-flex flex-column">
              <span class="name">
                Designation
              </span>
              <span class="details">
                Manager
              </span>
            </div>

          </div>

        </div>
      </div>
      <!-- <div class="padding-left-employees">
                <div class="line "></div>
            </div> -->
      <div class="d-flex justify-textbox padding-left-employees mt-4">
        <div class="activation-width mt-3">
          <span class="pr-4 activation">Activation </span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="activation" value="activation" [(ngModel)]="activation"
              (ngModelChange)="toggleActivationSelection($event)" (change)="toggleActivationSelection($event)">
            <span class="slider round "></span>
            <ng-template #contentActivation let-modal class="text-center">
              <div class="modal-height">
                <div class="modal-body">
                  <div class="">
                    <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
                    <div class="popup-line"></div>
                  </div>
                </div>
                <div class="submit col-12 d-flex justify-content-end ">
                  <div class="pr-3">
                    <button type="button " class="cancel-button pt-3"
                      (click)="modal.close('Save click');onCancel('activation')"><span
                        class="cancel">Cancel</span></button>
                  </div>
                  <button type="button " class="add-button"><span class="add"
                      (click)="updateTenantMember();modal.close('Save click') ">{{statusText}}</span></button>
                  <!-- <span class="pt-2 text-color" (click)="modal.close('Save click')">Cancel</span> -->
                  <!-- <button type="button" class=" col-6" (click)="modal.close('Save click')">CANCEL</button> -->
                </div>
              </div>
            </ng-template>
            <!-- <label class="checkbox-label">activation</label> -->
          </label>
        </div>
        <!-- <div class="activation-width pl-4 mt-3 ">
          <span class="pr-4 activation">Privilege </span>
          <label class="switch pl-5">
            <input type="checkbox" [(ngModel)]="priviledge" [checked]="employeeDetails?.isPriviledge"
              [value]="employeeDetails?.isPriviledge" (ngModelChange)="togglePriviledgeSelection($event)"
              (change)="togglePriviledgeSelection($event)">
            <span class="slider round "></span>
            <ng-template #contentPriviledge let-modal class="text-center">
              <div class="modal-height">
                <div class="modal-body">
                  <div class="">
                    <div class="text pt-3 pb-3">Are you sure, you want to revoke privilege</div>
                    <div class="popup-line"></div>
                  </div>
                </div>
                <div class="submit col-12 d-flex justify-content-end ">
                  <div class="pr-3">
                    <button type="button " class="cancel-button pt-3"
                      (click)="modal.close('Save click');onCancel('priviledge')"><span
                        class="cancel">Cancel</span></button>
                  </div>
                  <button type="button " class="add-button"><span class="add"
                      (click)="revokeAccess('privilege')">Revoke</span></button>
                </div>
              </div>
            </ng-template>
          </label>
        </div> -->
      </div>
      <div class="padding-left-employees padding-right-employees">
        <div class="line "></div>
      </div>

      <div class="d-flex justify-content-between mt-5">
        <div class="padding-left-employees access">
          Access
        </div>
        <div class="justify-content-end padding-right-employees">
          <span class="pr-5 select-all">Select all</span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="allSelected" value="allSelected" [(ngModel)]="allSelected"
              (change)="toggleSelectAllSelection($event)" [disabled]="!activation" class="checkbox">
            <span [ngClass]="(activation)?'slider round ':'sliderr roundd'"></span>
          </label>
        </div>
      </div>
      <div *ngIf="entryGate.length>0">
        <span class="padding-left-employees entry-gate">Entry Gate</span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let eg of entryGate;let i=index">
            <div class="pr-4 d-flex">
              <div (click)="changeAccess(eg,'entryGate')" [ngClass]="(eg.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(eg.selected)?'text-font':'text-font-deselected'">{{eg.label}}</span>
              </div>
              <span>
                <img *ngIf="eg.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(eg,'entryGate')"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="meetingRoomAccess.length>0">
        <span class="padding-left-employees entry-gate ">Meeting Room Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(mr,'meetingRoomAccess')"
                [ngClass]="(mr.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(mr.selected)?'text-font':'text-font-deselected'">{{mr.label}}</span>
              </div>
              <span>
                <img *ngIf="mr.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(mr,'meetingRoomAccess')"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="deskAccess.length>0" style="display: none;">
        <span class="padding-left-employees entry-gate ">Desk Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let da of deskAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(da,'deskAccess')" [ngClass]="(da.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(da.selected)?'text-font':'text-font-deselected'">{{da.label}}</span>
              </div>
              <span>
                <img *ngIf="da.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(da,'deskAccess')"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="privateSuiteAccess.length>0">
        <span class="padding-left-employees entry-gate ">Private Suite Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let ps of privateSuiteAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(ps,'privateSuiteAccess')"
                [ngClass]="(ps.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(ps.selected)?'text-font':'text-font-deselected'">{{ps.label}}</span>
              </div>
              <span>
                <img *ngIf="ps.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(ps,'privateSuiteAccess')"></span>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- <div class="mt-4">
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let mr of accessPointListName?.list;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(mr,'meetingRoomAccess')"
                [ngClass]="(mr.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(mr.selected)?'text-font':'text-font-deselected'">{{mr.accessPointName}}</span>
              </div>
              <span>
                <img *ngIf="mr.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(mr,'meetingRoomAccess')"></span>
            </div>
          </ng-container>
        </div>
      </div> -->
    </div>
  </div>

</div>
